import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Grid from '@mui/material/Grid';
import { connect } from 'react-redux';
import moment from 'moment';
import {
  Field2 as Field,
  viAdd,
  viTrash,
  VibeIcon,
  color,
  ToastActions,
} from 'vibeguide';
import './CampaignValueAdjustments.scss';

function CampaignValueAdjustments({
  className,
  style,
  editCampaignValueAdjustments,
  currencyCode,
  segmentStartDate,
  segmentEndDate,
  onChangeCampaign,
  APISavingError,
  onRemoveRow,
  user,
}) {
  const titleStyle = {
    fontSize: 16,
    fontWeight: 'bold',
    color: color.secondary,
  };

  /**
   * Change a row date
   */
  const onChangeDate = (e, rowId) => {
    onChangeCampaign('date', e, rowId);
  };

  /**
   * Change a row spend
   */
  const onChangeSpend = (e, rowId) => {
    onChangeCampaign('spend', e, rowId);
  };

  /**
   * Add a Campaign Value Row
   */
  const onAddRow = () => {
    onChangeCampaign('add-row', '', '');
  };

  return (
    <div
      className={classNames('CampaignValueAdjustments', className)}
      style={style}
    >
      <Grid spacing={2} container>
        {/* Type */}
        <Grid size={12}>
          <Grid spacing={2} container>
            <Grid size={12}>
              <div
                style={titleStyle}
              >
                Campaign Value Adjustments
              </div>
              {APISavingError && <div className="error">No changes have been saved.</div>}
            </Grid>

            {editCampaignValueAdjustments.map((valueAdjustment, i) => {
              return (
                <Grid key={i} sx={{ pt: 2, marginLeft: 0 }} spacing={2} container>
                  <Grid size={6}>
                    <Field
                      type="datepicker"
                      label="Date"
                      placeholder="YYYY-MM-DD"
                      value={valueAdjustment.date}
                      style={{
                        width: '100%',
                      }}
                      dateProps={{
                        format: 'YYYY-MM-DD',
                        tooltipDate: moment(valueAdjustment.date)
                          .startOf('day')
                          .format('YYYY-MM-DD [at] HH:mm:ss'),
                        minDate: moment(segmentStartDate).toDate(),
                        maxDate: moment(segmentEndDate).toDate(),
                      }}
                      tabIndex={28}
                      testId={`campaign-value-adjustment-${i}-date-input`}
                      onChange={(e) => onChangeDate(e, i)}
                      disabled={!user.can('order_segment.modify_campaign_value_adjustments')}
                    />
                  </Grid>

                  <Grid size={5}>
                    <Field
                      type="currency"
                      label="Spend"
                      name="spend"
                      value={valueAdjustment.spend}
                      currencyProps={{
                        currencyCode,
                      }}
                      tabIndex={29}
                      testId={`campaign-value-adjustment-${i}-spend-input`}
                      onChange={(e) => onChangeSpend(e, i)}
                      disabled={!user.can('order_segment.modify_campaign_value_adjustments')}
                    />
                  </Grid>

                  <Grid sx={{ marginTop: '24px', paddingLeft: 0 }} size={1}>
                    <VibeIcon
                      style={{
                        position: 'relative',
                        display: 'block',
                        cursor: 'pointer',
                        margin: '0 auto',
                      }}
                      icon={viTrash}
                      color={color.primary}
                      size={20}
                      disabled={!user.can('order_segment.modify_campaign_value_adjustments')}
                      data-testid={`campaign-value-adjustment-${i}-remove-button`}
                      onClick={() => onRemoveRow(i)}
                    />
                  </Grid>
                </Grid>
              );
            })}

            {user.can('order_segment.modify_campaign_value_adjustments') && (
              <Grid size={12}>
                <div
                  onClick={onAddRow}
                  className="add-campaign-row"
                  data-testid="campaign-value-adjustment-add-button"
                >
                  <VibeIcon
                    icon={viAdd}
                    color={color.primary}
                    size={12}
                  />
                  <span>
                    Add Adjustment
                  </span>
                </div>
              </Grid>
            )}
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
}

CampaignValueAdjustments.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  editCampaignValueAdjustments: PropTypes.arrayOf(PropTypes.shape({
    date: PropTypes.string,
    spend: PropTypes.number,
  })),
  currencyCode: PropTypes.string,
  segmentStartDate: PropTypes.string,
  segmentEndDate: PropTypes.string,
  onChangeCampaign: PropTypes.func,
  APISavingError: PropTypes.bool,
  onRemoveRow: PropTypes.func,
};

CampaignValueAdjustments.defaultProps = {
  className: '',
  style: {},
  editCampaignValueAdjustments: [],
  currencyCode: '',
  segmentStartDate: '',
  segmentEndDate: '',
  onChangeCampaign: () => {},
  APISavingError: false,
  onRemoveRow: () => {},
};

function mapStateToProps(state) {
  return {
    user: state.login.user,
  };
}

const mapDispatchToProps = {
  queueToast: ToastActions.queueToast,
};

export default connect(mapStateToProps, mapDispatchToProps)(CampaignValueAdjustments);
